import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import { decimalTo } from '../../../utils/utils';

import { api } from '../../../api';

export default function DashboardTable(props) {
  const token = useSelector((state) => state.auth.token);
  const [tableData, setTableData] = useState([])
  const navigate = useNavigate();
  useEffect(() => {
    api.orders.getDashboardOrders({
      pageNo: 1,
      pageSize: 10,
      sort: 'desc',
      sortBy: 'orderId'
    },token).then(res => {
      if (res && res.data && res.data.result) {
      setTableData(res.data.result);
    } else {
      setTableData([]); 
    }
    })
  }, [token]);

  return (
    <section className="mt-4 container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="box-row">
            <div className="card">

              <h1 className="sec-header float-left mt-3 ml-3">Latest Orders</h1>
              <div className="card-body gatepass-saveoutput">
                <div className="reports">
                  <div style={{ overflowX: 'auto' }}>

                    <table className="table">
                      <thead>
                        <tr>
                          <th>Order Date</th>
                          <th>Merchant Name</th>
                          <th>Products</th>
                          <th>Order ID</th>
                          <th>Quantity</th>
                          <th>Amount</th>
                          <th>Margin</th>
                          <th>Net Amount</th>
                          <th>Available Balance</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>

                        {tableData.length > 0 && tableData.map((dt, index) => {
                          let discounts=dt.savingAmount===null?0:dt.savingAmount
                          return (
                            <tr key={index}>
                              <td>{dt.orderDate}</td>
                              <td><Link to={`view-merchants/${dt.merchantId}`}><span className="add-ellip">{dt.merchentName}</span></Link></td>
                              <td><span className="add-ellip">{dt.ordersItems}</span></td>
                              <td>{dt.orderNo}</td>
                              <td>{dt.ordersQuantity}</td>
                              {/* <td>{(dt.orderAmount + discounts).toFixed(2)}</td> */}
                              <td>{dt.orderAmount ? decimalTo(dt.orderAmount).toFixed(2) : 0.00}</td> 
                              <td>{dt.savingAmount ? decimalTo(dt.savingAmount).toFixed(2) : 0.00}</td> 
                              <td>{decimalTo(dt.orderAmount - discounts).toFixed(2)}</td>
                              <td>{dt.balanceCredit ? decimalTo(dt.balanceCredit.toFixed(2)).toFixed(2) : 0.00}</td> 
                              <td>{dt.status}</td>
                              <td><span className="view-btn" onClick={() => navigate(`/orders-info/${dt.orderId}`)} ><p className="ViewButton">View</p></span></td>
                            </tr>
                          )
                        })}
                        {
                          tableData.length === 0 &&
                          <tr>
                            <td colSpan='11' className="noData">No data found</td>
                          </tr>
                        }

                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
